// Taken from Cynthia Brewer's colorbrewer (http://colorbrewer.org/)

// 9-class YlGn with a gray appended
export const colors = [
  "#004529",
  "#006837",
  "#238443",
  "#41ab5d",
  "#78c679",
  "#addd8e",
  "#d9f0a3",
  "#f7fcb9",
  "#ffffe5",
  "#d9d9d9",
];

export type RGB = [number, number, number];

const white: RGB = [255, 255, 255];
const black: RGB = [0, 0, 0];

// https://www.w3.org/TR/WCAG22/#dfn-relative-luminance
const relativeLuminance = (rgb: RGB): number => {
  const [r, g, b] = rgb.map((value) => {
    const channel = value / 255;
    return channel <= 0.04045
      ? channel / 12.92
      : Math.pow((channel + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// https://www.w3.org/TR/WCAG22/#dfn-contrast-ratio
export const contrastRatio = (a: RGB, b: RGB): number => {
  const [lighter, darker] = [relativeLuminance(a), relativeLuminance(b)].sort(
    (x, y) => y - x,
  );
  return (lighter + 0.05) / (darker + 0.05);
};

// Whether white text has more contrast than black text on this background.
// Colors not in #rrggbb form count as light.
export const isDark = (hexcolor: string): boolean => {
  const match = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hexcolor);
  if (!match) {
    return false;
  }
  const rgb = match.slice(1).map((hex) => parseInt(hex, 16)) as RGB;
  return contrastRatio(rgb, white) > contrastRatio(rgb, black);
};
